import { render, staticRenderFns } from "./virtualForm.vue?vue&type=template&id=a9b5dc0e&scoped=true&"
import script from "./virtualForm.vue?vue&type=script&lang=js&"
export * from "./virtualForm.vue?vue&type=script&lang=js&"
import style0 from "./virtualForm.vue?vue&type=style&index=0&id=a9b5dc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5dc0e",
  null
  
)

export default component.exports